module.exports = __webpack_public_path__ + "static/1-fce76dac445640f0a3835835622469fc.png";